import { render, staticRenderFns } from "./ChatSidebar.vue?vue&type=template&id=45b630bf&scoped=true"
import script from "./ChatSidebar.vue?vue&type=script&lang=js"
export * from "./ChatSidebar.vue?vue&type=script&lang=js"
import style0 from "./ChatSidebar.vue?vue&type=style&index=0&id=45b630bf&prod&lang=scss&scoped=true"
import style1 from "./ChatSidebar.vue?vue&type=style&index=1&id=45b630bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b630bf",
  null
  
)

export default component.exports